exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reset-password[data-v-f0d4e14a] {\n  padding: 20px 30px;\n}\n", ""]);

// exports
